import * as Sentry from '@sentry/react';
import { VITE_RELEASE, VITE_SENTRY_DSN, VITE_SENTRY_ENVIRONMENT } from '../constants';

export const setupSentry = () => {
  const dsn = VITE_SENTRY_DSN;
  const environment = VITE_SENTRY_ENVIRONMENT;
  const release = VITE_RELEASE;

  if (dsn && environment) {
    Sentry.init({
      dsn: dsn,
      environment: environment,
      release: release,
    });
  }
};
